import addTherapies from '../components/AddTherapies.vue'

export default {
    data () {
        return {
            therapiesStatus:false
        }
    },
    components:{
        addTherapies
    },
    methods: {
        // 添加治疗项目
        addTreatmentItems() {
            this.therapiesStatus = true;
        },
        setTherapiesStatus(val){
            this.therapiesStatus = val;
        }
    },
}